<template>
  <transition name="slide-fade">

    <div class="rTableRow" style="position: relative">
      <div class="rTableCell table_code">
        <el-input
          v-validate="{ required: isItemRequired }"
          controls-position="right"
          :name="'code_' + index"
          v-model="item_row.code"
          :disabled="true"
        ></el-input>
        <label
          v-show="errors.has('new-item.code_' + index)" class="error">
          {{ errors.first("new-item.code_" + index) }}
        </label>
      </div>
      <div class="rTableCell table_name">
        <autocomplete
          v-model="item_row.name"
          :items="items"
          :selected="selected"
          :index="index"
          v-validate="{ required: isItemRequired }"
          :name="'name_' + index"
          @selectItem="addItem"
        >
        </autocomplete>
        <label v-show="errors.has('new-item.name_' + index)" class="error">
          {{ errors.first("new-item.name_" + index) }}
        </label>
      </div>

      <div class="rTableCell table_inventory_quantity">
        <el-input
          v-validate="{ required: isItemRequired }"
          controls-position="right"
          :name="'inventory_quantity_' + index"
          :min="0.1"
          v-model="item_row.inventory_quantity"
           :disabled="true"
        ></el-input>
        <label
          v-show="errors.has('new-item.inventory_quantity_' + index)"
          class="error"
        >
          {{ errors.first("new-item.inventory_quantity_" + index) }}
        </label>
      </div>

      <div class="rTableCell table_quantity">
        <el-input-number
          @change="changeTarifa()"
          v-validate="{ required: isItemRequired }"
          controls-position="right"
          :name="'quantity_' + index"
          :min="0.1"
          :max="1000000000000"
          v-model="item_row.quantity"
        ></el-input-number>
        <label
          v-show="errors.has('new-item.quantity_' + index)"
          class="error"
        >
          {{ errors.first("new-item.quantity_" + index) }}
        </label>
      </div>

      <div class="rTableCell table_cost_price">
        <el-input-number
          @change="changeTarifa()"
          v-validate="{ required: isItemRequired }"
          controls-position="right"
          :name="'cost_price_' + index"
          :min="0.1"
          :max="1000000000000"
          v-model="item_row.calculate_price"
        ></el-input-number>
        <label
          v-show="errors.has('new-item.cost_price_' + index)"
          class="error"
        >
          {{ errors.first("new-item.cost_price_" + index) }}
        </label>
      </div>

      <div class="rTableCell table_discount">
        <el-input-number
          v-validate="{ required: isItemRequired }"
          style="width:60px !important"
          :min="0"
          :max="max_value_percent"
          :controls="false"
          :name="'discount_' + index"
          v-model="item_row.discount"
        ></el-input-number>
        <label
          v-show="errors.has('new-document.discount_' + index)"
          class="error"
        >
          {{ errors.first("new-document.discount_" + index) }}
        </label>
        <label>
          <input
            @change="changeTarifa()"
            type="checkbox"
            name="percent"
            v-model="item_row.percent"
            />Porcentaje
        </label>
      </div>

      <div class="rTableCell table_tax">
        <el-select
          style="width:92px;margin:0"
          no-data-text="No hay datos."
          no-match-text="No hay resultados."
          placeholder=""
          v-model="item_row.tax_type"
          value-key="id"
          :name="'tax_type_' + index"
          v-validate="{ required: isItemRequired }"
          filterable
          class="form-control"
        >
          <el-option
            v-for="tax_type in tax_types"
            :key="tax_type.id"
            :label="tax_type.rate + '%'"
            :value="tax_type"
          >
          </el-option>
        </el-select>
        <label v-show="errors.has('tax_type_' + index)" class="error">
          {{ errors.first("tax_type_" + index) }}
        </label>
      </div>

      <div class="rTableCell table_total last-column" style="position:relative">
        <el-button
          @click.prevent="removeItem()"
          size="mini"
          type="danger"
          icon="el-icon-delete"
          circle
          class="btn-delete-item"
        >
        </el-button>
        {{
          (item_row.percent==true ? 
          (((item_row.calculate_price * item_row.quantity -
            (item_row.calculate_price * item_row.quantity * item_row.discount) /
              100) *
            item_row.tax_type.rate) /
            100 +
            (item_row.calculate_price * item_row.quantity -
              (item_row.calculate_price *
                item_row.quantity *
                item_row.discount) /
                100))
            :
            (((item_row.calculate_price * item_row.quantity - item_row.discount) *
            item_row.tax_type.rate) /
            100 +
            (item_row.calculate_price * item_row.quantity - item_row.discount)))
            | currency({ symbol: selected_currency.symbol, fractionCount: 5 })
        }}
      </div>

      
    </div>

    <!-- Payment Modal -->
    <!-- <exoneration-modal @exonerationExecuted="executedExoneration" @closeModal="closeModal()" :vis="exoneration_modal"></exoneration-modal> -->
  </transition>
</template>

<script>
import Autocomplete from "@/components/Autocomplete.vue";
import SearchItem from "@/components/SearchItem.vue";
import { mapState, mapActions } from "vuex";
// import { ExonerationModal } from '@/components/ExonerationModal.vue';
import utilitiesService from "@/services/utilities.service";
import inventoriesService from '@/services/inventories.service.js';

export default {
  inject: ["$validator"],
  name: "row-item-inventory",
  data() {
    return {
      loadingSearch: false,
      cabysCodes: [],
      exoneration_modal: false
    };
  },
  components: {
    Autocomplete,
    SearchItem
    // ExonerationModal
  },
  props: {
    items: {
      required: true
    },
    index: {
      required: true
    },
    selected_currency: {
      required: true
    },
    item: {
      required: false
    }
  },
  computed: {
    ...mapState(["tax_types", "units", "exchange_rate", "selected_items"]),
    //El id del item actual para el autocomplete
    selected() {
      return this.item.id;
    },
    item_row() {
      return this.item;
    },
    isItemRequired() {
      let required = true;
      if (this.selected_items.length >= 1) {
        this.selected_items.forEach(i => {
          if (i.name !== "" && i.calculate_price >= 0.1) {
            required = false;
          }
        });
      }
      return required;
    },
    min_value_price() {
      let min = 0.1;
      if (this.selected_items.length >= 1) {
        this.selected_items.forEach(i => {
          if (i.name !== "" && i.calculate_price >= 0.1) {
            min = 0;
          }
        });
      }
      return min;
    },
    max_value_percent() {
      let max = 100;
      if (this.selected_items.length >= 1) {
        if (!this.item.percent) {
          max = 1000000000000;
        }
      }
      
      return max;
    }
  },
  methods: {
    ...mapActions(["getUnits", "getTaxTypes"]),
    addExoneration() {
      this.exoneration_modal = true;
    },
    executedExoneration() {
      this.exoneration_modal = false;
      //this.transaction.paymen
    },
    closeModal() {
      this.exoneration_modal = false;
    },
    changeTarifa() {
      let item = this.item_row;
      item = JSON.parse(JSON.stringify(item));

      item.price = item.calculate_price;
      this.updateItem(item);
      let selected_items = JSON.parse(JSON.stringify(this.selected_items));
      this.$store.dispatch("loadItems", { selected_items: selected_items });
    },
    changeTotal() {
      // console.log(this.item_row);
    },
    addItem(item, index) {
      item = JSON.parse(JSON.stringify(item));
      item.calculate_price = this.calculated_price(item.cost_price, item.currency);
      item.quantity = 1;
      item.discount = 0;
      item.percent = true;

      inventoriesService.getInventory(item.id).then(inv => {
        if (inv.data.item != null){
            item.max_quantity = inv.data.item.quantity
            // console.log(item.max_quantity)
        }
      }).catch(error1 => {
      });

      let selected_items = JSON.parse(JSON.stringify(this.selected_items));
      let exist_item = selected_items.find(i => i.id === item.id);

      if (exist_item) {
        if (exist_item.quantity < item.max_quantity){
          exist_item.quantity = exist_item.quantity + 1;
        }
        let exist_item_index = selected_items.indexOf(exist_item);
        this.$store.dispatch("updateItems", {
          item: exist_item,
          index: exist_item_index
        });
      } else {
        this.$store.dispatch("updateItems", { item: item, index: index });
        if (item.cabys_code) {
          this.cabysCodes.push(item.cabys_code);
        }
      }
    },
    updateAllItems() {
      let selected_items = JSON.parse(JSON.stringify(this.selected_items));
      let updated_items = selected_items.map(i => {
        i.calculate_price = this.calculated_price(i.cost_price, i.currency);
        return i;
      });
      this.$store.dispatch("loadItems", { selected_items: updated_items });
    },
    updateItem() {
      let item = this.item_row;
      this.$store.dispatch("updateItems", { item: item, index: this.index });
    },
    removeItem() {
      let items = this.selected_items;
      if (items.length === 1) return;
      items.splice(this.index, 1);
      this.$store.dispatch("deleteItem", { selected_items: items });
    },
    calculated_price(price, currency) {
      let value = 0;
      if (currency.id === this.selected_currency.id) {
        return price;
      }

      if (this.selected_currency.id === 1) {
        value = price / this.exchange_rate;
      } else if (this.selected_currency.id === 2) {
        value = price * this.exchange_rate;
      }
      return parseFloat(value).toFixed(2);
    },
    searchCabysCodes(search) {
      this.loadingSearch = true;
      this.getCabysCodes(search);
    },
    //Get cabys codes
    getCabysCodes(search = false) {
      utilitiesService
        .getCabysCodes(search)
        .then(res => {
          this.loadingSearch = false;
          this.cabysCodes = res.data;
        })
        .catch(error => {
          this.loadingSearch = false;
          this.$message({
            showClose: true,
            message: error.response.data.message,
            type: "error"
          });
        });
    },
    changeTaxType(val) {
      let tt = this.tax_types.find(i => i.name == "Exento");
      if (val.tax_rate != "Exento") {
        tt = this.tax_types.find(i => i.rate == val.tax_rate);
      }
      this.item_row.tax_type = tt;
    }
  },
  watch: {
    item_row: {
      deep: true,
      handler(item, oldItem) {
        oldItem = JSON.parse(JSON.stringify(oldItem));
        item = JSON.parse(JSON.stringify(item));
        if (item.id === 0) {
          if (item.price === 0) {
            item.price = oldItem.calculate_price;
          }
        }
        this.updateItem(item);
      }
    },
    selected_currency() {
      this.updateAllItems();
    }
  },
  created() {
    this.getTaxTypes();
    this.getUnits();
    this.getCabysCodes();
  }
};
</script>

<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100px);
  opacity: 0;
}
.slide-fade {
  position: relative;
}
.last-column {
  position: relative;
}
.btn-delete-item {
  position: absolute;
  top: 21px;
  right: 0px;
  display: none;
}
.rTableRow:hover .btn-delete-item {
  display: block !important;
}
</style>
